export const defaultChartTheme = {
    backgroundColor: 'transparent',
    textColor: 'var(--text-neutral-white, #FFFFFF)',
    fontFamily: 'var(--font-family-base)',
    axis: {
        x: {
            labelColor: 'var(--text-neutral-white, #FFFFFF)',
            lineColor: 'var(--stroke-neutral-silver, #CCCCCC)',
            tickColor: 'var(--stroke-neutral-silver, #CCCCCC)',
            fontSize: 12,
            fontFamily: 'var(--font-family-base)',
        },
        y: {
            labelColor: 'var(--text-neutral-white, #FFFFFF)',
            lineColor: 'var(--stroke-neutral-silver, #CCCCCC)',
            tickColor: 'var(--stroke-neutral-silver, #CCCCCC)',
            fontSize: 12,
            fontFamily: 'var(--font-family-base)',
        },
    },
    grid: {
        stroke: 'var(--stroke-neutral-subtle, #F2F2F2)',
        strokeDasharray: '3 3',
    },
    tooltip: {
        backgroundColor: 'var(--background-white, #FFFFFF)',
        borderColor: 'var(--stroke-neutral-silver, #CCCCCC)',
        textColor: 'var(--text-neutral-dark, #1F1F1F)',
    },
    legend: {
        textColor: 'var(--text-neutral-white, #FFFFFF)',
        show: false,
    },
    markers: {
        show: true,
        size: 6,
    },
    yAxisFormatter: (value) => {
        if (value >= 1000) {
            return `${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)}K`;
        }
        return value.toString();
    },
};
export function mergeChartTheme(customTheme) {
    if (!customTheme)
        return defaultChartTheme;
    return {
        ...defaultChartTheme,
        ...customTheme,
        axis: {
            x: { ...defaultChartTheme.axis?.x, ...customTheme.axis?.x },
            y: { ...defaultChartTheme.axis?.y, ...customTheme.axis?.y },
        },
        grid: { ...defaultChartTheme.grid, ...customTheme.grid },
        tooltip: { ...defaultChartTheme.tooltip, ...customTheme.tooltip },
        legend: { ...defaultChartTheme.legend, ...customTheme.legend },
        markers: { ...defaultChartTheme.markers, ...customTheme.markers },
    };
}
